import React from "react";
import "./BanksModal.scss";
import ReactModal from "react-modal";
import { Col, Container, Row, Button, Modal, Form } from "react-bootstrap";
import { Formik } from "formik";
import Select from "react-select";
import { addAppBank, changeOtpMobileNumber } from "../../api/index";
import Loader from "../loader/loader";
import * as yup from "yup";
import Cleave from "cleave.js/react";

const phoneRegex =
    /^\(?(?:[0-9]{3})\)?[-.\s+]?(?:[0-9]{3})[-.\s+]?(?:[0-9]{4})$/;
const countryCodeRegex = /^(\+?\d{1,3}|\d{1,4})$/;

const schema = yup.object({
    showRequiredField: yup.string().oneOf(["yes", "no"]),
    otp_phone_number: yup
        .string()
        .matches(phoneRegex, "* Input phone number correctly.")
        .when("showRequiredField", (fieldRequired, schema) => {
            return fieldRequired === "yes"
                ? schema
                : schema.required("*Phome number is required");
        }),
});

class EditMobileNumberModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuCLose: true,
            show_spinner: false,
            error: "",
            phone: "",
            mobileModalShow: false,
            otp_phone_prefix: "+1",
            formData: {
                otp_phone_number: props.mobile ? props.mobile : "",
                otp_phone_number_2:
                    props.mobile_2 !== null ? props.mobile_2 : null,
            },
            errors: [],
        };
    }
    onSubmit = async () => {
        const formData = this.state.formData;
        let data = new FormData();
        let number = this.state.otp_phone_prefix + formData.otp_phone_number;
        data.append("otp_phone_number", number);
        if (formData.otp_phone_number_2) {
            let number2 =
                this.state.otp_phone_prefix + formData.otp_phone_number_2;
            data.append("otp_phone_number_2", number2);
        }
        data.append("editslug", this.props.slug);
        data.append("id", this.props.appId);
        this.setState({ show_spinner: true });
        changeOtpMobileNumber(data)
            .then((response) => {
                this.setState({ show_spinner: false });
                this.props.mobileUpdate();
                this.props.handleClose();
            })
            .catch((error) => {});
    };

    handleOnChange = (e) => {
        const targetName = e.target.name;
        let formData = this.state.formData;
        const rawValue = e.target.rawValue || "";
        if (rawValue) {
            this.setState((prevState) => ({
                ...prevState,
                [targetName]: rawValue.trim(),
            }));
        }
        formData[targetName] = e.target.rawValue.trim();
    };

    render() {
        const { show_spinner, formData } = this.state;
        return (
            <ReactModal isOpen={this.props.show} className="banks-modal">
                <div className="modal-header">
                    <h4 className="text-left">
                        Please enter your mobile phone number
                    </h4>
                </div>
                <div className="modal-body" style={{ marginTop: "50px" }}>
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(e) => this.onSubmit(e)}
                        initialValues={formData}
                        validateOnBlur={false}
                    >
                        {({
                            errors,
                            touched,
                            handleChange,
                            values,
                            handleSubmit,
                        }) => (
                            <Form
                                noValidate
                                autoComplete="off"
                                onSubmit={handleSubmit}
                                onChange={(e) => this.handleOnChange(e)}
                            >
                                <Form.Row>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <div className="d-flex flex-row phone-prefix">
                                            <Cleave
                                                options={{
                                                    blocks: [3, 3, 4],
                                                    delimiter: "-",
                                                    numericOnly: true,
                                                }}
                                                required
                                                placeholder="OTP mobile"
                                                name="otp_phone_number"
                                                value={values.otp_phone_number}
                                                onChange={handleChange}
                                                type="text"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                className={`preapp-form-input form-control ${
                                                    !errors.otp_phone_number &&
                                                    ""
                                                } ${
                                                    touched.otp_phone_number &&
                                                    !!errors.otp_phone_number &&
                                                    "is-invalid"
                                                }`}
                                            />
                                        </div>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.otp_phone_number}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        {/* ... existing phone number input */}
                                    </Form.Group>
                                </Form.Row>
                                {this.props.mobile_2 !== null && (
                                    <Form.Row>
                                        <Form.Group
                                            as={Col}
                                            xs={12}
                                            className="px-3"
                                        >
                                            <div className="d-flex flex-row phone-prefix">
                                                <Cleave
                                                    options={{
                                                        blocks: [3, 3, 4],
                                                        delimiter: "-",
                                                        numericOnly: true,
                                                    }}
                                                    required
                                                    placeholder="Second OTP mobile"
                                                    name="otp_phone_number_2"
                                                    value={
                                                        values.otp_phone_number_2
                                                    }
                                                    onChange={handleChange}
                                                    type="text"
                                                    inputMode="numeric"
                                                    pattern="[0-9]*"
                                                    className={`preapp-form-input form-control ${!errors.otp_phone_number_2 && ""} ${
                                                        touched.otp_phone_number_2 &&
                                                        !!errors.otp_phone_number_2 &&
                                                        "is-invalid"
                                                    }`}
                                                />
                                            </div>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {errors.otp_phone_number_2}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>
                                )}
                                <div
                                    className="modal-footer"
                                    style={{ marginTop: "250px" }}
                                >
                                    <button
                                        className="btn cancel-button"
                                        onClick={this.props.handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="btn confirm-button"
                                        type="submit"
                                    >
                                        Update
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
                {show_spinner ? (
                    <div className="spinner">
                        <Loader />
                    </div>
                ) : (
                    ""
                )}
            </ReactModal>
        );
    }
}

export default EditMobileNumberModal;
